import React from 'react';
import { I18n } from '@td/shared_utils';
import PropTypes from 'prop-types';

import MedicationServiceLineAvailability from './medication-service-line-availability';
import { DrugListMap } from '../../types/drugListMap';
import { RefState } from '../../types/refState';

export const SERVICE_LINE_DRUG_LIST_NAME = {
  general_medical: 'GENERAL',
  mental_health: 'BH_DOC',
  dermatology: 'DERM',
  primary_care: 'P360',
};

const MedicationAvailability = ({ drugListMaps, refStates, drugId }) => {
  const filterDrugListMapsForServiceLine = serviceLine =>
    drugListMaps.filter(drugListMap => drugListMap.drugList.name === SERVICE_LINE_DRUG_LIST_NAME[serviceLine]);

  return (
    <section className="medication-availability">
      <h2>
        <I18n scope="medication_formularies.details.availability" text="title" />
      </h2>
      <ul className="medication-service-line-availabilities">
        {Object.keys(SERVICE_LINE_DRUG_LIST_NAME).map(service_line => (
          <li key={service_line}>
            <MedicationServiceLineAvailability
              serviceLine={service_line}
              drugListMaps={filterDrugListMapsForServiceLine(service_line)}
              refStates={refStates}
              drugId={drugId}
            />
          </li>
        ))}
      </ul>
    </section>
  );
};

MedicationAvailability.propTypes = {
  drugListMaps: PropTypes.arrayOf(DrugListMap).isRequired,
  refStates: PropTypes.arrayOf(RefState).isRequired,
  drugId: PropTypes.string.isRequired
};

export default MedicationAvailability;
